import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AppChakraProvider } from "acsiss-ui";
import { theme } from "./theme/theme";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <AppChakraProvider theme={theme}>
    <App />
  </AppChakraProvider>
);
